import { useEffect, useState } from "react";
import { getLocalId } from "easy-analytics/client";
import { getDate } from "easy-analytics/client";
import { api, handleError } from "../../services/api";

import { Footer, Header } from "../../Layout";

import { Countdown } from "../../../types";
import { useRouter } from "easy-page-router/react";
import { useHead } from "../../services/common";
import { useLang } from "../../services/lang";
import { CountdownPreview } from "./Countdown";
import { ThemeSelect, ThemeSwitch } from "../../components/Theme";
import { LangSwitch } from "../../components/Lang";
import { Loading, Page } from "../../components";
import { CheckboxPublic, Input } from "../../components/Form";

const emptyCountdown: Countdown = {
    _id: "",
    userId: "",
    changed: "",
    lang: "en",
    theme: "",
    title: "",
    description: "",
    countdown: "",
    messageAfter: "",
    where: "",
    public: false,
}

function getDefaultCountdown() {
    const date = new Date();
    date.setDate(date.getDate() + 1);

    return date.toISOString().slice(0, 10) + "T00:00";
}

export default function CountdownForm() {
    const { push } = useRouter();
    const { lang, dict } = useLang();

    useHead({
        title: dict.seo.countdownForm.title,
        description: dict.seo.countdownForm.description,
    });

    const [countdown, setCountdown] = useState(emptyCountdown);

    useEffect(() => {
        setCountdown(c => ({
            ...c,
            countdown: getDefaultCountdown(),
        }));
    }, []);

    const [message, setMessage] = useState("");
    const [isSending, setIsSending] = useState(false);

    async function handleSave() {
        if (!countdown.title) {
            return setMessage(dict.formMissingTitle);
        }
        if (!countdown.countdown) {
            return setMessage(dict.formMissingCountdown);
        }

        setIsSending(true);
        setMessage("");

        const [id, error] = await api.addCountdown({
            ...countdown,
            userId: getLocalId(),
            changed: getDate(),
            lang,
        });

        setIsSending(false);

        if (!id) {
            handleError(error);
            setMessage(dict.fromCountdownError);
        } else {
            setMessage(dict.fromCountdownSuccess);
            push(`/${dict.urlCountdown}/${id}`);
        }
    }

    return <Page fixed={<>
        <Header title={dict.countdown} link={`/${dict.urlCountdown}`}>
            <LangSwitch />
            <ThemeSwitch />
        </Header>
        <Footer />
    </>}>

        <h1>{dict.newCountdown}</h1>

        <div className="countdown-form">
            <div className="form">
                <label>{dict.theme}</label>
                <ThemeSelect
                    hidePreview
                    value={countdown.theme}
                    onChange={theme => setCountdown({ ...countdown, theme })}
                />

                <Input autoFocus label={dict.countdownFormTitle} field="title" maxLength={100} required value={countdown} setValue={setCountdown} />
                <Input label={dict.countdownFormWhen} field="countdown" required type="datetime-local" value={countdown} setValue={setCountdown} />
                <Input label={dict.countdownFormMessageAfter} field="messageAfter" maxLength={100} placeholder={dict.defaultMessageAfter} value={countdown} setValue={setCountdown} />
                <Input label={dict.countdownFormWhere} field="where" value={countdown} maxLength={50} setValue={setCountdown} />
                <Input label={dict.formDescription} field="description" maxLength={500} type="textarea" value={countdown} setValue={setCountdown} />

                <CheckboxPublic
                    value={countdown}
                    onChange={setCountdown}
                    label={dict.countdownFormPublic}
                    captionPublic={dict.countdownFormPublicCaption}
                    captionPrivate={dict.countdownFormPrivateCaption}
                />

                {message && <p className="alert">{message}</p>}

                {isSending && <Loading />}
                {!isSending && <button onClick={handleSave}>{dict.createCountdown}</button>}

            </div>
            <div className="preview-column">
                <CountdownPreview className="block" countdown={countdown} />
            </div>
        </div>
    </Page>;
}
